import fetch from './ajax'

export const DEBUG = false // 是否开发模式
// const ROOT_DEV = '/xj/topic2017/' // 测试地址
// const ROOT_DEV = 'https://didi.360che.com/topic2017/' // 测试地址
const ROOT = 'https://topic.360che.com/topics/' // 正式地址
// const ROOTS = DEBUG ? ROOT_DEV : ROOT
// const URLS = `${ROOTS}` // 正式地址
class XHR {
  // 获取微信jssdk config接口
  getWechatJsSdk (json) {
    return fetch({
      url: 'https://m.360che.com/article2014/articleajax20140901.aspx?type=18',
      body: json,
      type: 'GET'
    })
  }

  // 获取手工位信息
  getHandWork (json) {
    return fetch({
      url: `${ROOT}api/handwork/gethandwork.aspx`,
      body: json,
      type: 'GET'
    })
  }

  // 整车接口
  getCarStatus (json) {
    return fetch({
      url: 'https://maiche.360che.com/activity/info',
      body: json,
      type: 'GET'
    })
  }

  // 获取车型亮点
  getBrightPoints (json) {
    return fetch({
      url: `${ROOT}api/handwork/gethandwork.aspx?type=13&hid=3841`,
      body: json,
      type: 'GET'
    })
  }

  // 获取车型评测
  getEvaluate (json) {
    return fetch({
      url: `${ROOT}api/handwork/gethandwork.aspx?type=9&hid=3861`,
      body: json,
      type: 'GET'
    })
  }

  // 获取精美图赏
  getEnjoyImg (json) {
    return fetch({
      url: `${ROOT}api/handwork/gethandwork.aspx?type=13&hid=3842`,
      body: json,
      type: 'GET'
    })
  }

  // 获取视频列表
  getVideoList (json) {
    return fetch({
      url: `${ROOT}api/handwork/gethandwork.aspx?type=19&hid=3843`,
      body: json,
      type: 'GET'
    })
  }
}
export default new XHR()
